@for (columnParam of tableColumnsParams; track $index) {
  @if (!columnParam.omit) {
    @if (isColumnDisplayed(columnParam)) {
      <div
        class="body-cell"
        [class]="{
          'separator': columnParam.separated,
          'sticky': columnParam.sticky
        }"
        [attr.data-column]="columnParam.key"
        [style.left.px]="columnParam.leftPositionForStickyColumn"
        [style.width.px]="getWidth(columnParam)"
      >
        @if (columnParam.editable) {
          @if (columnParam.filterType === 'PRODUCT_ARTICLE_MULTI_SELECT') {
            <app-dynamic-single-select-table-item
              [columnParam]="columnParam"
              [value]="null"
              [isEdit]="columnParam.editable"
              [required]="columnParam.required"
              [dynamicValue]="columnParam.key === 'productId' ? newRecordData['article'] : newRecordData['productId']"
              (valueChanged)="updateRecordDataForCreation(columnParam.key, $event)"
            />
          } @else {
            @switch (columnParam.type) {
              @case ('TEXT') {
                <app-text-record-table-item
                  [columnParam]="columnParam"
                  [value]="''"
                  [isEdit]="columnParam.editable"
                  [required]="columnParam.required"
                  (valueChanged)="updateRecordDataForCreation(columnParam.key, $event)"
                  (inputValueChanged)="updateRecordDataForCreation(columnParam.key, $event)"
                />
              }
              @case ('NUMERIC') {
                <app-number-record-table-item
                  [columnParam]="columnParam"
                  [value]="''"
                  [isEdit]="columnParam.editable"
                  [required]="columnParam.required"
                  (valueChanged)="updateRecordDataForCreation(columnParam.key, $event)"
                />
              }
              @case ('NUMBER') {
                <app-number-record-table-item
                  [columnParam]="columnParam"
                  [value]="''"
                  [isEdit]="columnParam.editable"
                  [required]="columnParam.required"
                  (valueChanged)="updateRecordDataForCreation(columnParam.key, $event)"
                />
              }
              @case ('DATE') {
                <app-date-record-table-item
                  [columnParam]="columnParam"
                  [value]="''"
                  [isEdit]="columnParam.editable"
                  [required]="columnParam.required"
                  (valueChanged)="updateRecordDataForCreation(columnParam.key, $event)"
                />
              }
              @case ('DATE_YEAR') {
                <app-year-record-table-item
                  [columnParam]="columnParam"
                  [value]="''"
                  [isEdit]="columnParam.editable"
                  [required]="columnParam.required"
                  (valueChanged)="updateRecordDataForCreation(columnParam.key, $event)"
                />
              }
              @case ('DATE_MONTH_YEAR') {
                <app-month-year-record-table-item
                  [columnParam]="columnParam"
                  [value]="''"
                  [isEdit]="columnParam.editable"
                  [required]="columnParam.required"
                  (valueChanged)="updateRecordDataForCreation(columnParam.key, $event)"
                />
              }
              @case ('SELECT') {
                <app-single-select-table-item
                  [columnParam]="columnParam"
                  [value]="null"
                  [isEdit]="columnParam.editable"
                  [required]="columnParam.required"
                  (valueChanged)="updateRecordDataForCreation(columnParam.key, $event)"
                />
              }
              @case ('ENUM_SELECT') {
                <app-single-select-table-item
                  [columnParam]="columnParam"
                  [value]="null"
                  [isEdit]="columnParam.editable"
                  [required]="columnParam.required"
                  (valueChanged)="updateRecordDataForCreation(columnParam.key, $event)"
                />
              }
              @case ('MULTI_SELECT') {
                <app-multi-select-table-item
                  [columnParam]="columnParam"
                  [value]="null"
                  [isEdit]="columnParam.editable"
                  [required]="columnParam.required"
                  (valueChanged)="updateRecordDataForCreation(columnParam.key, $event)"
                />
              }
              @case ('ENUM_MULTI_SELECT') {
                <app-multi-select-table-item
                  [columnParam]="columnParam"
                  [value]="null"
                  [isEdit]="columnParam.editable"
                  [required]="columnParam.required"
                  (valueChanged)="updateRecordDataForCreation(columnParam.key, $event)"
                />
              }
              @case ('MODAL') {
                <div class="disabled-control"></div>
              }
              @case ('IFRAME') {
                <div class="disabled-control"></div>
              }
            }
          }

        } @else {
          <div class="disabled-control"></div>
        }
      </div>
    }
    @if (columnParam.separated) {
      <div class="separator-column"></div>
    }
    @if (columnParam.hiddenGroupPlaceholder) {
      <div
        app-hidden-group
        class="hidden-group-placeholder"
        [resourceParamsKey]="resourceParamsKey"
        [columnParams]="columnParam"
      ></div>
    }
  }
}

@if (isAnyTableActionAvailable) {
  <div class="body-cell table-action">
    <div class="disabled-control"></div>
  </div>
}
